<div class="container">
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
</div>